import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import Faq from "../components/universal-components/Faq";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import ContentLeft from "../components/ContentLeft";
import ContentRight from "../components/ContentRight";
import CallToAction from "../components/CallToAction";
import { plumbingContent } from "../page-content/plumbingContent";

const Plumbing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={plumbingContent} />
      <Intro data={plumbingContent} />
      <ContentLeft data={plumbingContent} />
      <ContentRight data={plumbingContent} />
      <CallToAction data={plumbingContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default Plumbing;
